import axios, { AxiosError } from "axios";
import { BadRequestType } from "../types/BadRequestType";
import { getAuthentication } from "../helpers/token";

const options = {
  baseURL: import.meta.env.VITE_REACT_APP_BACKEND_ADDRESS as string,
  headers: {
    "Content-Type": "application/json",
  },
};

const API = axios.create(options);

const reloadOptions = () => {
  API.interceptors.request.use(function (config) {
    config.headers.Authorization = `Bearer ${getAuthentication()}`;

    return config;
  });
};

const handleErrorApi = (
  error: AxiosError<BadRequestType>
): string | undefined => {
  const errors = error.response?.data.errors;

  if (!errors || errors.length === 0) return undefined;

  return errors.join("\r\n");
};

export { API, reloadOptions, handleErrorApi };
